
import * as _asset0 from "inline-asset:assets/galleries/featured/suj1_c8014a19e0__20.jpg";
import * as _asset1 from "asset:assets/galleries/featured/suj1_c8014a19e0__400.jpg";
import * as _asset2 from "asset:assets/galleries/featured/suj1_c8014a19e0__800.jpg";
import * as _asset3 from "asset:assets/galleries/featured/suj1_c8014a19e0__1600.jpg";


export default {
  id: "suj1",
  aspect: 1.502883506343714,
  alt: undefined,
  sources: [{
              url: _asset0.url,
              width: 20,
            },{
              url: _asset1.url,
              width: 400,
            },{
              url: _asset2.url,
              width: 800,
            },{
              url: _asset3.url,
              width: 1600,
            }],
};
        